import { ModuleWithProviders, NgModule } from '@angular/core';
import {
    MSAL_GUARD_CONFIG,
    MSAL_INSTANCE,
    MSAL_INTERCEPTOR_CONFIG,
    MsalBroadcastService,
    MsalGuard,
    MsalModule,
    MsalRedirectComponent,
    MsalService,
} from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory } from './msal-auth.utilities';
import { MsalAuthConfig } from './msal-auth-config.interface';
import { PaceMsalAuthService } from './msal-auth.service';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { PaceMsalOfflineCapableInterceptor } from './msal-offline-capable.interceptor';
import { PaceMsalXIdTokenInterceptor } from './msal-x-id-token.interceptor';
import { PaceEnvironment } from '@evorait/pace-core';

@NgModule({
    imports: [MsalModule],
    providers: [MsalService, MsalGuard, MsalBroadcastService, PaceMsalAuthService],
    exports: [MsalModule],
    bootstrap: [MsalRedirectComponent],
})
export class PaceMsalAuthenticationModule {
    public static forRoot(environment: PaceEnvironment): ModuleWithProviders<PaceMsalAuthenticationModule> {
        const authConfig: MsalAuthConfig = {
            clientId: environment.clientId ?? '',
            authority: environment.authority ?? '',
            odataRequestUrl:
                !!environment.serviceProtocol && !!environment.serviceHost
                    ? `${environment.serviceProtocol}://${environment.serviceHost}`
                    : '',
            fxAppScope: environment.fxAppScope ?? '',
            btpApimScope: environment.btpApimScope ?? '',
            graphApiUrl: environment.graphApiUrl ?? '',
        };
        if (
            authConfig.authority === '' ||
            authConfig.clientId === '' ||
            authConfig.odataRequestUrl === '' ||
            !authConfig.graphApiUrl ||
            !authConfig.fxAppScope ||
            !authConfig.btpApimScope
        ) {
            console.error('MSAL: ENVIRONMENT CONFIGURATION IS MISSING VALUES!');
        }
        return {
            ngModule: PaceMsalAuthenticationModule,
            providers: [
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: PaceMsalOfflineCapableInterceptor,
                    multi: true,
                },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: PaceMsalXIdTokenInterceptor,
                    multi: true,
                },
                {
                    provide: MSAL_INSTANCE,
                    useFactory: (log: LogInterface) =>
                        MSALInstanceFactory(authConfig.clientId, authConfig.authority, log),
                    deps: [LogInstanceToken],
                },
                {
                    provide: MSAL_GUARD_CONFIG,
                    useFactory: () => MSALGuardConfigFactory(authConfig.fxAppScope),
                },
                {
                    provide: MSAL_INTERCEPTOR_CONFIG,
                    useFactory: () =>
                        MSALInterceptorConfigFactory(
                            [authConfig.odataRequestUrl],
                            authConfig.fxAppScope,
                            authConfig.graphApiUrl,
                        ),
                },
            ],
        };
    }
}
